// extracted by mini-css-extract-plugin
module.exports = {"component":"Post_component__H1o12","title":"Post_title__bsBi4","postInfo":"Post_postInfo__hv16w","featuredImage":"Post_featuredImage__jiJUW"};